import type { MenuProps } from "antd";
import { Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import CommonIcons from "@base/assets/icons";
import CommonStyles from "@base/components/CommonStyles";
import { ENABLE_LANGUAGE_SWITCHER, languageApp } from "@base/constants";
import { DEFAULT_LANGUAGE } from "@base/language/lang";

interface IProps {
  // "dropdown" is the flag pill used in the header bar, "select" the plain list used inside the drawer.
  variant?: "dropdown" | "select";
  onChanged?: () => void;
}

const LanguageSwitcher = ({ variant = "dropdown", onChanged }: IProps) => {
  //! state
  const { i18n } = useTranslation();
  const currentLanguage = languageApp.find((item) => item.value === i18n.resolvedLanguage) ?? languageApp[0];

  //! function
  const changeLanguage = (lang: string) => {
    // i18next writes the pick to localStorage itself (detection.caches), so it survives a reload.
    i18n.changeLanguage(lang);
    onChanged?.();
  };

  //! render
  // Everything above and below works; the switcher is only kept out of the UI for now.
  if (!ENABLE_LANGUAGE_SWITCHER) {
    return null;
  }

  if (variant === "select") {
    return (
      <CommonStyles.SelectUI
        className="border-none"
        value={i18n.resolvedLanguage ?? DEFAULT_LANGUAGE}
        onChange={changeLanguage}
        options={languageApp.map((item) => ({ label: item.label, value: item.value }))}
      />
    );
  }

  const languageItems: MenuProps["items"] = languageApp.map((item) => ({
    key: item.value,
    label: (
      <div className="flex items-center justify-start gap-1 group">
        <div>
          <img src={item.img} alt={item.title} />
        </div>
        <CommonStyles.NavLinkTextUI hover className="group-hover:!text-common-mainColor" text={item.label} />
      </div>
    ),
    onClick: () => {
      changeLanguage(item.value);
    },
  }));

  return (
    <Dropdown menu={{ items: languageItems }} placement="bottomLeft">
      <div className="rounded-[100px] cursor-pointer">
        <div className="flex items-center gap-2 px-2 py-1 border border-common-divider rounded-3xl">
          <div>
            <img src={currentLanguage.display} alt={currentLanguage.title} />
          </div>
          <div>
            <CommonIcons.IconDown />
          </div>
        </div>
      </div>
    </Dropdown>
  );
};

export default LanguageSwitcher;
